import * as HLF from "html-living-framework";

import { PatchShapes, PatchShapeType } from "../Data/PatchShapes";
import { PatchTemplateData } from "../Data/PatchTemplateData";

export const BASIC_SHAPES: PatchShapeType[] = [
    PatchShapeType.SQUARE_SMALL,
    PatchShapeType.SQUARE_LARGE,
    PatchShapeType.LINE_SMALL,
    PatchShapeType.ELBOW,
];

export const UNIQUE: PatchTemplateData[] = [
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.LINE_LARGE],
        false,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.LINE_LARGE],
        true,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.LINE_LARGE],
        false,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.LINE_LARGE],
        true,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.ELBOW],
        true,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.ELBOW],
        true,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.ELBOW],
        true,
    ),
    new PatchTemplateData(
        PatchShapes.data[PatchShapeType.ELBOW],
        true,
    ),
];

export function randomBasic(pShapes: PatchShapeType[]): PatchTemplateData {
    return new PatchTemplateData(
        PatchShapes.data[HLF.ArrayUtils.random(pShapes)],
        true,
    );
}
